// extracted by mini-css-extract-plugin
export default {"root":"eSk8tZet9LZDWrHWGyuU","left":"JuSD_PzqFg6ktD7JDCnf","right":"bmpMc6RPN1mA_B4qdc5l","logo":"fXtr18cUOjT98igPphrp","name":"UAIqjctBulUD6Ds5DTBa"};